export default class Constants {
    static END_POINT = {
        LOGIN: "/login",
        PROFILE: "/profile",
        FORGET_PASSWORD: "/forget-password",
        UPDATE_PROFILE: "/update",
        RESET_PASSWORD: "/change-forget-password",
        UPLOAD_FILES: "/upload/file",
        CHANGE_PASSWORD: "/change-password",
        UPLOAD_FILE: "/upload/file",

        //Dashborad

        GET_USERS_COUNT: "/user/count",
        NOTIFICATION: "/notification",
        CHANGE_APP_DESC: "/constant",

        //USER

        USER: "/users/",
        USER_DISABLE: "/users-disable/",
        USER_SOFT_DELETE: "/users-soft-delete/",
        USER_RESTORE: "/users-restore/",
        VEHICLE_SEARCH_USERS: "/vehicle-search-users/",
        SHIPPING_ORDER: "/order/",
        REPLACEMENT: "/replacement-request/",
        QR_CODE: "/qr-code/",
        UNASSIGNED_QR_CODE: "/qr-code-unassigned/",
        TAG_QR_CODE: "/qr-code/vehicle-tagging/",
        ASSIGN_QR_CODE: "/qr-code/assign/",
        EXPIRED_MEMBERSHIPS: "/users-expired-memberships",

        // EXECUTIVE
        EXECUTIVE: "/executive/",
        EXECUTIVE_DISABLE: "/executive-disable/",
        EXECUTIVE_EARNINGS: "/executive-revenue/",
        EXECUTIVE_PAYROLL: "/executive-payroll/",

        // SUPPORT QUERIES
        SUPPORT_QUERIES: "/support/",
        SUPPORT_MARK_ALL_READ: "/support/mark-all-read",

        // BANNERS
        BANNER: "/banner/",
        BANNER_UPLOAD: "/banner/upload",

        // VEHICLE BRANDS
        VEHICLE_BRANDS: "/vehicle-brand/",

        // VEHICLE MODELS
        VEHICLE_MODELS: "/vehicle-model/",

        // STATIC PAGES
        STATIC_PAGES: "/static-page/",

        // DASHBOARD
        DASHBOARD: "/dashboard/",

        // CALL_LOGS
        CALL_LOGS: "/call-logs/",
        CALL_RECORDINGS: "/call-recordings/",

        //New Orders

        NEW_ORDERS_COUNT: "/new-orders-count",
        IMPORT_VEHICLE_BRAND: "/vehicle-brand-bulk/",
        IMPORT_VEHICLE_MODAL: "/vehicle-model-bulk/",
        //Invoice
        INVOICE:"/invoices",
        PAYMENT_HISTORY: "/payment-history",
        GET_INVOICE:"/invoice/",
        //Plans
        PLANS:"/plan",
        SUBSCRIPTION_PLAN:"/plan/subscription",

        // DEMO VIDEO
        DEMO_VIDEO: "/demo-video",

        // USER SUBSCRIPTIONS
        USER_SUBSCRIPTIONS: "/user-subscriptions",
        GRANT_PREMIUM: "/user-subscriptions/grant-premium",
        ADD_CREDITS: "/user-subscriptions/add-credits",
        DECREASE_CREDITS: "/user-subscriptions/decrease-credits",

        // SUB-ADMINS
        SUB_ADMINS: "/sub-admin",
        SUB_ADMIN_PERMISSION_CATALOG: "/sub-admin/permission-catalog",
    };
}
